import React, { useEffect } from 'react';
import { List, Row, Col, Input, Select } from 'antd';
import styled from 'styled-components';
import { Rectangle, SkyscraperMobile } from 'components/Ads';
import { useRouter } from 'next/router';
import Content from 'layout/Basic/Content';
import Sider from 'layout/Basic/Sider';
import Pagination from 'components/Pagination';
import { SectionTitle } from 'components/Section';
import { useState } from 'react';
import createFromObject from 'lib/queryString';
import Section from 'components/Section';
import Item from './Item';

const { Search } = Input;

const { Option } = Select;

interface Props {
    events: {
        items: Occurrence[];
        results: number;
        currentPage: number;
        numberOfPages: number;
        next: boolean;
        prev: boolean;
        paginate: boolean;
    };
    ads: PageAds;
    branch: Branch;
    $sectionTitle: string;
}

const SearchStyled = styled(Search)`
    border-width: 0 0 1px 0;
`;

export const EventList = ({ events, branch, $sectionTitle, ads }: Props): React.JSX.Element => {
    const { items, currentPage, results, paginate, next, prev } = events || {
        items: [],
        currentPage: 1,
        results: 0
    };
    const [page, setPage] = useState<number | null>(currentPage);
    const [searchByName, setSearchByName] = useState<string | null>(null);
    const [searchByType, setSearchByType] = useState<string | null>(null);
    const [searchByBranch, setSearchBranch] = useState<string | null>(null);
    const router = useRouter();

    useEffect(() => {
        if (router.query.branch) {
            setSearchBranch(router.query.branch as string);
        }
        if (router.query.type) {
            setSearchByType(router.query.type as string);
        }
        if (router.query.name) {
            setSearchByName(router.query.name as string);
        }
    }, []);

    const onChange = (page) => {
        setPage(page);
        const query = createFromObject({
            page,
            name: searchByName,
            type: searchByType,
            branch: searchByBranch
        });
        router.push(query);
    };
    const sectionTitleText = branch ? `Najnowsze z ${branch.title}` : $sectionTitle;

    const onSearchByName = (name: string) => {
        setPage(1);
        setSearchByName(name);
        const query = createFromObject({
            page,
            name: name,
            type: searchByType,
            branch: searchByBranch
        });
        router.push(query);
    };
    const onSearchByType = (type: string) => {
        setPage(1);
        setSearchByType(type);
        const query = createFromObject({
            page,
            name: searchByName,
            type: type,
            branch: searchByBranch
        });
        router.push(query);
    };

    const { skyscraper, rectangle } = ads;
    return (
        <>
            <Row>
                <Content>
                    <Row>
                        <SectionTitle title={sectionTitleText} />
                    </Row>
                    <Section gutter={24}>
                        <Col xs={24} md={16}>
                            <SearchStyled
                                placeholder="Wpisz nazwę wydarzenia"
                                enterButton
                                size="large"
                                onSearch={onSearchByName}
                                allowClear
                                value={searchByName}
                                onChange={(e) => {
                                    setSearchByName(e.target.value);
                                }}
                            />
                        </Col>
                        <Col xs={24} md={8}>
                            <Select
                                style={{ width: '100%' }}
                                size="large"
                                value={searchByType}
                                placeholder="Typ wydarzenia"
                                onSelect={onSearchByType}
                                allowClear
                                onClear={() => {
                                    onSearchByType(null);
                                }}
                            >
                                <Option value="targi">Targi</Option>
                                <Option value="szkolenie">Szkolenie</Option>
                                <Option value="konferencja">Konferencja</Option>
                                <Option value="promocja">Promocja</Option>
                                <Option value="inne">Inne</Option>
                            </Select>
                        </Col>
                    </Section>
                </Content>
            </Row>
            <Section>
                <Content>
                    <Row>
                        <Col span={24}>
                            <List
                                size="large"
                                itemLayout="horizontal"
                                dataSource={items}
                                rowKey={({ seoSlug }: Occurrence): string => seoSlug}
                                renderItem={(item: Occurrence, i: number) => {
                                    if (i === 0) {
                                        return (
                                            <List.Item>
                                                <Item item={item} />
                                                <Row>
                                                    <Col xs={24} sm={12}>
                                                        <SkyscraperMobile
                                                            id={skyscraper[0]}
                                                            margin="16px auto 16px auto"
                                                        />
                                                    </Col>
                                                    <Col xs={24} sm={12}>
                                                        <SkyscraperMobile
                                                            id={skyscraper[1]}
                                                            margin="12px auto 16px auto"
                                                        />
                                                    </Col>
                                                </Row>
                                            </List.Item>
                                        );
                                    }
                                    return (
                                        <List.Item>
                                            <Item item={item} />
                                        </List.Item>
                                    );
                                }}
                            />
                        </Col>
                    </Row>
                    {paginate && (
                        <Row justify="center">
                            <Col span={24}>
                                <Pagination
                                    currentPage={currentPage}
                                    pageSize={10}
                                    results={results}
                                    onChange={onChange}
                                    prev={prev}
                                    next={next}
                                />
                            </Col>
                        </Row>
                    )}
                </Content>
                <Sider>
                    <Row>
                        <Col span={24}>
                            <Rectangle id={rectangle[0]} margin="16px auto" />
                        </Col>
                        <Col span={24}>
                            <Rectangle id={rectangle[1]} margin="16px auto" />
                        </Col>
                        <Col span={24}>
                            <Rectangle id={rectangle[2]} margin="16px auto" />
                        </Col>
                        <Col span={24}>
                            <Rectangle id={rectangle[3]} margin="16px auto" />
                        </Col>
                        <Col span={24}>
                            <Rectangle id={rectangle[4]} margin="16px auto" />
                        </Col>
                        <Col span={24}>
                            <Rectangle id={rectangle[5]} margin="16px auto" />
                        </Col>
                        <Col span={24}>
                            <Rectangle id={rectangle[6]} margin="16px auto" />
                        </Col>
                        <Col span={24}>
                            <Rectangle id={rectangle[7]} margin="16px auto" />
                        </Col>
                        <Col span={24}>
                            <Rectangle id={rectangle[8]} margin="16px auto" />
                        </Col>
                        <Col span={24}>
                            <Rectangle id={rectangle[9]} margin="16px auto" />
                        </Col>
                        <Col span={24}>
                            <Rectangle id={rectangle[10]} margin="16px auto" />
                        </Col>
                        <Col span={24}>
                            <Rectangle id={rectangle[11]} margin="16px auto" />
                        </Col>
                        <Col span={24}>
                            <Rectangle id={rectangle[12]} margin="16px auto" />
                        </Col>
                        <Col span={24}>
                            <Rectangle id={rectangle[13]} margin="16px auto" />
                        </Col>
                        <Col span={24}>
                            <Rectangle id={rectangle[14]} margin="16px auto" />
                        </Col>
                    </Row>
                </Sider>
            </Section>
        </>
    );
};

export default EventList;
